import { CrFilter } from '../customer-review-star-filter/types';

export type SortParameter = 'byDate' | 'byHelpful' | 'byStar' | 'byStarDescending' | 'initial';

export const isSortParameter = (value: string): value is SortParameter => {
    return ['byDate', 'byHelpful', 'byStar', 'byStarDescending', 'initial'].includes(value);
};

export type PagesForCrFilters = Record<CrFilter, number>;
